import { history } from 'src/config/history';

export class NavigationService {
    public navigate(path: string, state?: {}): void {
        // if the path is a fully qualified URL, don't push the path to history
        if (path.indexOf('http') === 0) {
            window.location.replace(path);
        } else {
            history.push(path, state);
        }
    }

    public goBack(): void {
        history.goBack();
    }

    public goForward(): void {
        history.goForward();
    }

    public replace(path: string): void {
        history.replace(path);
    }
}
